import(`@/../public/js/translations/config.js`);
for (const langKey of ['en', 'pl']) {
  for (const bundleKey of [
    'messages', 'FOSUserBundle', 'FOSMessageBundle',
    'SonataMediaBundle', 'AppAccounting', 'AppCalendar', 'AppProduct'
  ]) {
    import(`@/../public/js/translations/${bundleKey}/${langKey}.js`);
    // Main._httpFetchTranslations([
    //   `/js/translations/${bundleKey}/${langKey}.json`,
    // ]);
  }
}

const TransService = {
  _initTranslations() {
    // Main._httpFetchTranslations([
    //   '/js/translations/config.json',
    // ]);
    import(`@/../public/js/translations/config.js`);
    for (const langKey of ['en', 'pl']) {
      for (const bundleKey of [
        'messages', 'FOSUserBundle', 'FOSMessageBundle',
        'SonataMediaBundle', 'AppAccounting', 'AppCalendar', 'AppProduct'
      ]) {
        import(`@/../public/js/translations/${bundleKey}/${langKey}.js`);
        // Main._httpFetchTranslations([
        //   `/js/translations/${bundleKey}/${langKey}.json`,
        // ]);
      }
    }
  }
}

export default TransService;
